import { createFileRoute, notFound } from '@tanstack/react-router';

import { OrderDirection } from '#features/api/types';
import { blogPostsQueryOptions } from '#features/blog/model/blog';
import { getGamesQueryOptions } from '#features/game/model/services';
import { Landing } from '#features/landing/components/Landing';
import { landingPageQueryOptions } from '#features/landing/model/landing';
import { landingStatsQueryOptions } from '#features/landing/model/stats';
import { landingHead } from '#features/landing/utils/landingHead';

const gameSlug = 'index';

export const Route = createFileRoute('/{-$locale}/_layout/preview/landing/')({
  staticData: { rendersOwnFooter: true },
  component: RouteComponent,
  loader: async ({ context }) => {
    const landingDataPromise = context.queryClient.ensureQueryData(
      landingPageQueryOptions(gameSlug)
    );
    const blogPostsPromise = context.queryClient.ensureQueryData(
      blogPostsQueryOptions({
        limit: 3,
        offset: 0,
        orders: [{ direction: OrderDirection.DESC, field: 'date' }],
      })
    );
    const gamesPromise = context.queryClient.ensureQueryData(getGamesQueryOptions());

    const [landingData, _blogPosts, _games] = await Promise.all([
      landingDataPromise,
      blogPostsPromise,
      gamesPromise,
      context.queryClient.ensureQueryData(landingStatsQueryOptions()),
    ]);

    if (!landingData) {
      throw notFound({ routeId: '/{-$locale}/_layout' });
    }

    return {
      title: landingData.title,
      description: landingData.description,
      keywords: landingData.keywords,
      image: landingData.previewImage,
      name: landingData.name,
    };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) {
      return {};
    }
    const built = landingHead({
      title: loaderData.title,
      description: loaderData.description,
      keywords: loaderData.keywords,
      image: loaderData.image,
      gameSlug,
      gameName: loaderData.name,
      locale: params.locale,
      noindex: true,
    });
    return built;
  },
});

function RouteComponent() {
  return <Landing gameSlug="index" />;
}
